export default __webpack_public_path__ + "static/media/computer.d1cd66a8.svg";